import React from 'react';
import '../styles/preloader.css';

interface PreloaderProps {
  isLoading: boolean;
}

const Preloader: React.FC<PreloaderProps> = ({ isLoading }) => {
  return (
    <div className={`preloader ${isLoading ? 'visible' : ''}`}>
      <div className="sk-spinner-wave sk-spinner">
        <div className="sk-rect1"></div>
        <div className="sk-rect2"></div>
        <div className="sk-rect3"></div>
        <div className="sk-rect4"></div>
        <div className="sk-rect5"></div>
      </div>
    </div>
  );
};

export default Preloader; 